import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import ProgressBar from '../ProgressBar';
import Timer from '../Timer';
import { mapColor } from './config';
import { ProjectStatus } from 'src/utils/types';

const CountDown = ({
  className,
  contributors,
  percent,
  remainingTime,
  projectStatus
}) => {
  const color = mapColor[projectStatus];
  const disabled = remainingTime === 0 || projectStatus === ProjectStatus.ENDED;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.progress, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.row, disabled && styles.disabled)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.process
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Contributors Number:"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, contributors.toLocaleString('en-US'))), /*#__PURE__*/React.createElement("div", {
    className: styles.process
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Progress:"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, `${percent}%`))), /*#__PURE__*/React.createElement(ProgressBar, {
    percent: percent,
    color: color,
    className: classNames(styles.progressBar, projectStatus === ProjectStatus.UPCOMING ? styles.upcoming : undefined)
  }), /*#__PURE__*/React.createElement(Timer, {
    className: styles.timer,
    status: projectStatus,
    remainingTime: remainingTime,
    disabled: disabled
  }));
};

export default CountDown;